import {IStore} from "modules/types/store";
import {createSelector} from "reselect";
import {getFantasyTiles} from "modules/selectors/fantasy_tiles";
import {getEvents} from "modules/selectors/events";
import {get} from "lodash";

export const getErrorState = (store: IStore) => store.error;

export const getErrorModalMessage = createSelector(getErrorState, ({message}) => message);

export const getModalStore = (store: IStore) => store.modals;

export const isInvitesModalVisible = createSelector(
	getModalStore,
	({inviteSuccessModal}) => inviteSuccessModal.isShow
);
export const isInvitesModalSuccess = createSelector(
	getModalStore,
	({inviteSuccessModal}) => inviteSuccessModal.success
);

export const getIsShowWelcomeModal = createSelector(
	getModalStore,
	({welcomeModal}) => welcomeModal.isShow
);

export const getIsTermsModal = createSelector(getModalStore, ({termsModal}) => termsModal.isShow);
export const getIsLeaguesRolloverModal = createSelector(
	getModalStore,
	({leagueRolloverModal}) => leagueRolloverModal.isShow
);
export const getIsAuthenticationModal = createSelector(
	getModalStore,
	({authenticationModal}) => authenticationModal.isShow
);
export const getIsTermsNextSeason = createSelector(
	getModalStore,
	({termsNextSeason}) => termsNextSeason.isShow
);

export const getIsShowTournamentModal = createSelector(
	getModalStore,
	getFantasyTiles,
	getEvents,
	({tournamentModal}, tiles, events) => {
		const tile = tiles.find((tile) => tile.id === tournamentModal.tileId);
		const tileEventsIds = get(tile, "events", []);
		const tileEvents = tileEventsIds
			.map(({id}) => events.find((event) => event.id === id))
			.filter((event) => !!event);

		return {
			...tournamentModal,
			tile,
			events: tileEvents,
		};
	}
);

export const getIsShowBoostersModal = createSelector(
	getModalStore,
	({boostersModal}) => boostersModal.isShow
);

export const getIsShowAutoSwapModal = createSelector(
	getModalStore,
	({autoSwapModal}) => autoSwapModal
);

export const getIsShowAutoSubModal = createSelector(
	getModalStore,
	({autoSubModal}) => autoSubModal
);
